<template>
  <div class="connect-exchanges-content-create">
    <div class="connect-exchanges-content-create__numbers">1</div>
    <div class="connect-exchanges-content-create__step">
      <h4>Log in to Binance Spot</h4>
      <p>You need a Binance Spot account to create API keys.</p>
      <a
        class="connect-exchanges-content-create__step__button"
        href="https://www.binance.com/"
        target="_blank"
      >
        Visit www.binance.com to create account
      </a>
    </div>
    <div class="connect-exchanges-content-create__numbers">2</div>
    <div class="connect-exchanges-content-create__step">
      <h4>Access API Management</h4>
      <div class="connect-exchanges-content-create__step">
        <p>
          Hover over your profile icon at the top and select 'API Management'.
        </p>
      </div>
    </div>

    <div class="connect-exchanges-content-create__numbers">3</div>

    <div class="connect-exchanges-content-create__step">
      <h4>Create new API Key</h4>

      <p>Click 'Create API' and enter a name.</p>
    </div>

    <div class="connect-exchanges-content-create__numbers">4</div>

    <div class="connect-exchanges-content-create__step">
      <h4>Disable IP Restrictions</h4>
      <div class="connect-exchanges-content-create__step">
        <p>
          Click 'Edit Restrictions' under the API key you created. Make sure 'IP
          Access Restrictions' is set to 'Unrestricted'.
        </p>
        <p>
          Note: Protos does not require enabling deposit or withdrawal
          permissions for connected API keys.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConnectExchangesContentCreate",
};
</script>

<style lang="scss" scoped>
.connect-exchanges-content-create {
  display: grid;
  grid-template-columns: 1fr 20fr;
  gap: 2rem 0.5rem;

  &__step {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    position: relative;

    &__button {
      border-radius: 0.25rem;
      font-size: 0.875rem;
      font-weight: 600;
      padding: 0 0.5rem;
      line-height: 2.25rem;
      cursor: pointer;
      border: 1px solid black;
      text-decoration: none;
      color: black;
    }

    &__icon--1 {
      height: 1rem;
      position: absolute;
      right: 6rem;
      top: 0.25rem;
    }

    &__icon--2 {
      position: absolute;
      bottom: 4.7rem;
      height: 1rem;
      right: 7rem;
      top: 0.25rem;
    }

    p {
      font-size: 0.75rem;
      margin: 0;
      padding: 0;
      text-align: left;
      font-weight: 400;
    }

    h4 {
      font-size: 1.125rem;
      margin: 0;
      padding: 0;
    }
  }

  &__numbers {
    margin-top: -0.125rem;
    border: 1px solid black;
    border-radius: 50%;
    height: 1.5rem;
    line-height: 1.5rem;
    width: 1.5rem;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .connect-exchanges-content-create {

    &__step {

      &__icon--1 {
        right: 3rem;
      }

      &__icon--2 {
        right: 4.5rem;
      }

    }
  }  
}
</style>